import React from 'react';
import { useAuth } from "../../../context/auth";
import {makeStyles} from "@material-ui/core/styles";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';


const data = {
    level_stats: {
        "level5_competency": {
            widget_label: "Competency (level-5)",
            total_competencies: 8,
        },
        "level7_dqcode": {
            widget_label: "DQ Code (level-7)",
            total_dqcodes: 24,
            related_competencies: 8,
        },
        "level8_unit": {
            widget_label: "Unit (level-8)",
            total_units: 72,
            related_dqcodes: 24,
        },
        "level9_session": {
            widget_label: "Session (level-9)",
            total_sessions: 144,
            related_units: 72,
        },
        "target_group_and_age": {
            widget_label: "Target Group and Age",
            total_audience_combinations: 70,
        },

        "session_combinations": {
            widget_label: "Session Combinations",
            total_combinations: 12450,
            data_exist: 4200,
            total_combinations_without_audience: 2000,
            data_exist_without_audience: 1800,
        }
    }
}

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        marginTop: 10,
        marginBottom: 10
    },
    dashboardWidgets: {
        width: '100%',
        maxWidth: 1200,
        margin: '0 auto',
    },
    widgetPaper: {
        padding: theme.spacing(3),
        margin: theme.spacing(2),
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        background: '#fff',
    },
    widgetTitle: {
        marginBottom: theme.spacing(1),
        fontWeight: 600,
        fontSize: '1.2rem',
        color: theme.palette.primary.main,
    },
    widgetDetails: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
    },
    widgetDetail: {
        marginBottom: theme.spacing(0.5),
        display: 'flex',
        justifyContent: 'space-between',
    },
    detailKey: {
        fontWeight: 500,
        color: '#555',
    },
    detailValue: {
        color: '#222',
    },
}));

function DQCRTool_DashboardPage() {
    const classes = useStyles();
    const { authUser } = useAuth();

    return (
        <div className={classes.container}>
            <Grid container spacing={3} className={classes.dashboardWidgets}>
                {Object.entries(data.level_stats).map(([key, value]) => (
                    <Grid item xs={12} sm={6} md={4} key={key}>
                        <Paper className={classes.widgetPaper} elevation={3}>
                            <h4 className={classes.widgetTitle}>{value.widget_label}</h4>
                            <ul className={classes.widgetDetails}>
                                {Object.entries(value).map(([propKey, propValue]) => (
                                    propKey !== "widget_label" && (
                                        <li key={propKey} className={classes.widgetDetail}>
                                            <span className={classes.detailKey}>
                                              {propKey
                                                .replace(/_/g, ' ')
                                                .replace(/\b\w/g, char => char.toUpperCase())
                                              }:
                                            </span>
                                            <span className={classes.detailValue}>{propValue}</span>
                                        </li>
                                    )
                                ))}
                            </ul>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
}

export default DQCRTool_DashboardPage;